// extracted by mini-css-extract-plugin
export default {"blind_return_container":"_1dMw","add_icon_container":"vhSh","blind_return_copy_container":"_2h_x"};